import {useState,useEffect,useContext,useMemo} from "react"
import {Link,useLocation} from "react-router-dom"

import {Context,useFirestoreContext} from "../context/FirestoreContext.js"
import {useAuthContext} from "../context/AuthContext.js"

import {NavDropdown} from "react-bootstrap"//to style Dropdown only

import {writeDoc,uploadFile,downloadFile} from "../firebase.js"

function Navigation() {
  const { currentUser } = useAuthContext()
  const { pathname } = useLocation()
  const { state, dispatch } = useContext(Context)
  const { isCollapsed: isVisible } = state//Destructuring current state
  return (
    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
      <li className="nav-item">
        <Link className={`nav-link ${pathname==="/"?"active":""}`} aria-current="page" to="/">Home</Link>
      </li>
      {currentUser && (
        <li className="nav-item">
          <Link className={`nav-link ${pathname==="/mycomments"?"active":""}`} aria-current="page" to="/mycomments">My Comments</Link>
        </li>
      )}
      {currentUser && (
        <li className="nav-item">
          <button className="btn btn-success float-end" onClick={()=>dispatch({type:"collapse",payload:{bool:!isVisible}})}>
            {isVisible ? "Close Comment Form" : "Open Comment Form"}
          </button>
        </li>
      )}
    </ul>
  )
}
function LiveSearch() {
  const [text, setText] = useState("")
  const { filterItems: filter } = useFirestoreContext()
  function handleOnChange(e){
    const value = e.target.value
    setText(value)//Update state
    filter(value)//Filter items as user types
  }
  function handleOnSubmit(e){
    e.preventDefault()
    filter(text)//Filter items based on current text
  }
  return (
    <form className="d-flex" onSubmit={handleOnSubmit}>
      <input onChange={handleOnChange} className="form-control me-2" type="search" placeholder="Search Comments..." aria-label="Search"
        value={text} // Ensure input reflects the state
      />
    </form>
  )
}
function Dropdown() {
  const { currentUser } = useAuthContext()
  const username = useMemo(() => currentUser?.displayName || "Profile", [currentUser])
  const avatar = useMemo(() => (
    currentUser ? (
      <img className="avatar" src={currentUser.photoURL || 'favicon.ico'} alt="" width="50" height="50" />
    ) : "Login"
  ), [currentUser])
  return (
    <NavDropdown title={avatar} id="navbarDropdown">
      {currentUser && (
        <>
          <NavDropdown.Item as={Link} to="/profile" className="text-center">{username}</NavDropdown.Item>
          <NavDropdown.Divider />
        </>
      )}
      <div className="d-flex justify-content-center">
        <LogIn />
        <LogOut />
      </div>
    </NavDropdown>
  )
}
function LogIn(){
  const { login, currentUser } = useAuthContext()
  return (!currentUser && (<button type="button" className="btn btn-warning" 
    onClick={async ()=>{await login();window.location.href="/"}}>Login</button>))
}
function LogOut(){
  const { logout, currentUser } = useAuthContext()
  return (currentUser && (<button type="button" className="btn btn-danger" onClick={async ()=>{await logout();window.location.href="/"}}>Logout</button>))
}
function Navbar(){
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light mb-5">
      <div className="container-fluid">
        <a className="navbar-brand" href="https://projectsav.netlify.app/">
          <img src="favicon.ico" alt="" style={{height:'50px',width:'auto'}}/>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <Navigation />
          <LiveSearch />
          <Dropdown />
        </div>
      </div>
    </nav>
  )
}
function Preview(){
  const { state } = useContext(Context)
  const { inputs : { path } } = state//destructuring current state
  return (
    path && 
    <div className="rounded p-1 m-5" style={{width:"30%",height:"300px",backgroundImage:`url(${path}`,backgroundSize:"cover"}}></div>
  )
}
function CommentForm() {
  const { dispatch, state, read } = useContext(Context)
  const { currentUser } = useAuthContext();
  const { isCollapsed: isVisible, inputs } = state// destructuring current state
  function handleOnChange(e) {
    if (e.target.name === "file") {
      const file = e.target.files[0];
      if (file) {
        if (!file.type.startsWith("image/")) {
          alert("Image file only")
          return
        }
        if (file.size > 0.1 * 1024 * 1024) {
          alert("Your file size exceeds 100KB limit. Please select a smaller file")
          return
        }
      }
    }
    dispatch({ type: "setInputs", payload: { value: e } })
  }
  const username = currentUser?.displayName.split(" ").join("")
  function handleOnSubmit(e) {
    e.preventDefault()
    const uploadPromise = inputs.file ? uploadFile(state.inputs).then(downloadFile) : Promise.resolve(null)
    uploadPromise
      .then(url => {
        writeDoc({ ...inputs, path: url, user: username.toLowerCase() }, "comments").then(() => {
          read()
          dispatch({ type: "collapse", payload: { bool: false } })
        })
      })
  }
  const isDisabled = useMemo(() => {
    return !inputs.comment//disable if comment is empty
  }, [inputs])
  return (
    isVisible && 
    <>
      <p className="display-6 text-center mb-3">Comment Form</p>
      <div className="mb-5 d-flex align-items-center justify-content-center">
        <form className="mb-2" style={{ textAlign: "left" }} onSubmit={handleOnSubmit}>
          <div className="mb-3">
            <textarea className="form-control" name="comment" placeholder="Your comment..." aria-describedby="comment" rows="5" onChange={handleOnChange} />
          </div>
          <div className="mb-3">
            <i>Add your image? (optional,max size 100KB)</i>
            <input type="file" className="form-control" name="file" onChange={handleOnChange}/>
          </div>
          <button type="submit" className="btn btn-success float-end" disabled={isDisabled}>Add</button>
        </form>
        <Preview />
      </div>
    </>
  )
}
export default function Layout({ children }) {
  const { read } = useContext(Context)
  const { authenticate } = useAuthContext()
  useEffect(() => {
    read()
    authenticate()
  }, [authenticate, read])
  return (
    <>
      <Navbar />
      <CommentForm />
      {children}
    </>
  )
}